var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding-left":"10px","padding-right":"10px","height":"100%"}},[(_vm.isJXSql)?_c('sjj-editor-sql'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }